import {AppSection, SectionHooks} from "../Consts";

interface NavBarComponentProps {
    sectionName: AppSection;
}

const NavBarComponent = ({sectionName} : NavBarComponentProps) => (
    <nav className="fixed w-full bg-black/80 backdrop-blur-xl border-b border-white/10 z-50">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
            <div className="flex items-center justify-between h-16">
                <div className="flex items-center">
                    <span className="text-3xl font-black tracking-tighter">
                        <a href="#home"><span className="text-orange-500">Cage</span><span className="text-white">EEG</span></a>
                    {/**/}
                    </span>
                </div>
                <div className="hidden md:block">
                    <div className="ml-10 flex items-baseline space-x-8">
                        {/*<a href="#news"*/}
                        {/*   className="text-gray-300 hover:text-orange-500 px-3 py-2 text-sm font-medium transition-all duration-300">Aktualności</a>*/}
                        {/*<a href="#ourplans"*/}
                        {/*   className="text-gray-300 hover:text-orange-500 px-3 py-2 text-sm font-medium transition-all duration-300">Nasze Plany</a>*/}
                        {/*<a href="#aboutus"*/}
                        {/*   className="text-gray-300 hover:text-orange-500 px-3 py-2 text-sm font-medium transition-all duration-300">O nas</a>*/}
                        {/*<a href="#docs"*/}
                        {/*   className="text-gray-300 hover:text-orange-500 px-3 py-2 text-sm font-medium transition-all duration-300">Dokumentacja i badania</a>*/}
                        {/*<a href="#contact"*/}
                        {/*   className="text-gray-300 hover:text-orange-500 px-3 py-2 text-sm font-medium transition-all duration-300">Kontakt</a>*/}

                        {Object.values(SectionHooks[sectionName]).map((hook) => (
                            <a href={hook.Hash}
                               className="text-gray-300 hover:text-orange-500 px-3 py-2 text-sm font-medium transition-all duration-300">{hook.LinkName}</a>
                        ))}
                    </div>

                </div>
            </div>
        </div>
    </nav>
)

export default NavBarComponent
